export default {
  guides: {
    home: "https://gt3dao.gitbook.io/cnkt",
  },
}
